






















import Vue from "vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import DetectionCard from "../DetectionCard.vue";
import { detectionState } from "../data/state";
import { SharedState } from "@/common/state";
import { computed } from "@vue/composition-api";
import { UseTabs } from "@/common/composition/use-tabs";
import PIIRiskEventsBoard from "./PIIRiskEventsBoard.vue";
import { UseModal } from "@/components/root/modal";
import InfoTypeSeveritiesModalVue from "./infotype-severities-modal/InfoTypeSeveritiesModal.vue";
import { ICONS } from "@/common/icons.map";
export default Vue.extend({
  components: {
    DetectionCard,
    SimpleNavTabs,
    PIIRiskEventsBoard,
  },
  props: ["source"],
  setup(props) {
    const [tabs, selected_tab, set_selected_tab] = UseTabs<{
      id: string;
      name: string;
      icon: string;
      enabled: boolean;
    }>(
      [
        {
          id: "sensitive",
          name: "Sensitive Information",
          icon: "Label",
          enabled: true,
        },
        {
          id: "personal",
          name: "Personal Information",
          icon: "Regulated",
          enabled: true,
        },
      ].filter((d) => d.enabled),
      0
    );

    const { dashboard: cards, isLoading } = detectionState;

    const other_card = computed(() =>
      cards.value.find((d) => d.id == SharedState.default_label.value!.id)
    );

    const sensitivity_cards = computed(() =>
      cards.value.filter((d) => d.id !== SharedState.default_label.value!.id)
    );

    const drillDown = async (l0_id: string) => {
      const label = SharedState.getInfoType(l0_id)!;
      if (SharedState.restrictions.is_restricted_info(label.code)) {
        SharedState.restrictions.show_restrictions_modal(
          "info",
          label.labelName
        );
        return;
      }
      let label_ids;
      const l0_label = SharedState.get_raw_info_types_tree().find(
        (f) => f.id === l0_id
      );
      if (l0_label?.nested && l0_label?.nested.length > 0) {
        label_ids = l0_label.nested.map((d) => d.id);
      } else {
        label_ids = [l0_id];
      }

      console.log("label_ids : ", label_ids);
      await UseModal().show(InfoTypeSeveritiesModalVue, {
        source: props.source,
        label_name: label.labelName,
        label_icon: ICONS.L0_ICONS.get(label.code),
        label_ids,
      });
    };

    return {
      tabs,
      selected_tab,
      set_selected_tab,
      other_card,
      sensitivity_cards,
      feature_pii: SharedState.FeatureHelper.is_enabled("pii_labeler"),
      isLoading,
      drillDown,
    };
  },
});
